import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import api from '../lib/api';

const LOGO = '/logo.png';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); setMessage('Token no proporcionado'); return; }
    const verify = async () => {
      try {
        const { data } = await api.get(`/auth/verify-email?token=${token}`);
        setStatus('success'); setMessage(data.message);
      } catch (e) {
        setStatus('error'); setMessage(e.response?.data?.detail || 'Error al verificar');
      }
    };
    verify();
  }, [params]);

  return (
    <div data-testid="verify-email-page" className="min-h-[80vh] flex items-center justify-center px-4 bg-[#F4F5F7]">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="bg-white border-2 border-[#0B1F40] p-8 brutal-shadow text-center">
          <img src={LOGO} alt="RP" className="h-14 w-14 mx-auto mb-4 border-2 border-[#0B1F40]" />
          {status === 'loading' && (
            <>
              <Loader2 className="h-8 w-8 animate-spin text-[#E50B15] mx-auto mb-4" />
              <p className="text-sm text-[#0B1F40]/60 font-bold">Verificando tu correo...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
              <h1 className="text-xl text-[#0B1F40] mb-2" style={{ fontFamily: 'Archivo Black' }}>VERIFICADO</h1>
              <p className="text-sm text-[#0B1F40]/60 mb-6">{message}</p>
              <Link to="/login">
                <button className="w-full bg-[#E50B15] text-white font-black text-sm h-10 brutal-btn-press transition-all" style={{ boxShadow: '4px 4px 0px #0B1F40' }}>IR A INICIAR SESIÓN</button>
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="h-12 w-12 text-[#E50B15] mx-auto mb-4" />
              <h1 className="text-xl text-[#0B1F40] mb-2" style={{ fontFamily: 'Archivo Black' }}>ERROR</h1>
              <p className="text-sm text-[#E50B15] mb-6 font-bold">{message}</p>
              <Link to="/login">
                <button className="w-full bg-[#0B1F40] text-white font-black text-sm h-10 brutal-btn-press transition-all" style={{ boxShadow: '4px 4px 0px #E50B15' }}>IR AL INICIO</button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
